<template>
  <!-- The "Главная" / dashboard link is rendered globally by SideBar.vue
       (router-link to /{role}-dashboard), so it is intentionally not repeated here. -->
  <div class="sidebar__link-wrapper">
    <router-link to="/metodist-quiz-complaints" class="sidebar__link">
      <FlagIcon class="w-5 h-5" />
      <p>{{ $t("QuizComplaints.sidebar-complaints") }}</p>
    </router-link>
  </div>
</template>

<script setup>
import { FlagIcon } from "@heroicons/vue/24/outline";
</script>
